import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import SelectComponent from "../../../components/SelectComponent";
import { useMobileAppVersionContext } from "../../../context/MobileAppVersionContext/MobileAppVersionContext";
import { APP_OPTIONS, PLATFORM_OPTIONS } from "./constants";
import { useEffect, useState } from "react";

const GeneralInfo = () => {
	const { versionData, versionDetail, setVersionData } = useMobileAppVersionContext();
	const [version, setVersion] = useState<string | undefined>(versionDetail?.version);
	const [appOption, setAppOption] = useState<number | undefined>(versionDetail?.appId);
	const [platform, setPlatform] = useState<string | undefined>(versionDetail?.platform);

	useEffect(() => {
		setVersion(versionDetail?.version);
		setAppOption(versionDetail?.appId);
		setPlatform(versionDetail?.platform);
	}, [versionDetail?.version, versionDetail?.appId, versionDetail?.platform]);

	const getAppLabel = (appValue: number | undefined) => {
		const app = APP_OPTIONS.find(a => a.value === appValue);
		return app?.label || String(appValue);
	};

	const handleVersionChange = (value: string) => {
		const sanitizedVersion = value.replace(/[^0-9.]/g, "");
		setVersion(sanitizedVersion);
		setVersionData({ ...versionData, version: sanitizedVersion });
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={12}>
					<InputComponent
						title="Sürüm No"
						placeholder="Örn: 1.0.0"
						value={version}
						onChange={(e) => {
							handleVersionChange(e.target.value);
						}}
					/>
				</Col>
			</Row>
			<Row gutter={20}>
				<Col span={10}>
					<SelectComponent
						title="Uygulama"
						placeholder="Uygulama seçiniz"
						options={APP_OPTIONS}
						value={getAppLabel(appOption)}
						onChange={(value) => {
							setAppOption(Number(value));
							setVersionData({ ...versionData, appId: Number(value) });
						}}
					/>
				</Col>
				<Col span={10}>
					<SelectComponent
						title="Platform"
						placeholder="Platform seçiniz"
						options={PLATFORM_OPTIONS}
						value={platform}
						onChange={(value) => {
							setPlatform(value);
							setVersionData({ ...versionData, platform: value });
						}}
					/>
				</Col>
			</Row>
		</>
	);
};

export default GeneralInfo;
